<template>
  <div v-if="SIZES && activeSize" class="catalog-sku">
    <span
      v-for="(item, i) in SIZES.items"
      :key="item.value"
      :class="{ 'sku-item_disabled': item.disable || item.onOrder, 'sku-item_active': item.active }"
      class="sku-item"
      @click="getPageData({ url: item.detailPage })"
    >
      {{ item.displayValue }}
    </span>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'CatalogSKU',
  computed: {
    ...mapState({
      SIZES: ({ product }) => product.data?.product?.skuMatrix?.SIZES,
      messages: ({ product }) => product.data?.messages,
    }),
    ...mapGetters({
      activeSize: 'product/activeSize',
    }),
  },
  methods: {
    ...mapActions({
      getPageData: 'product/getPageData',
    }),
    getMessage(item) {
      const { onOrder, outOfStock } = this.messages;
      if (item.onOrder) {
        return onOrder;
      }
      return outOfStock;
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-sku {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.sku-item {
  display: flex;
  align-items: center;
  border: 1px solid #cacece;
  border-radius: 100px;
  height: 32px;
  padding: 0 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  &_active {
    background-color: var(--background-black);
    color: #fff;
  }

  &_disabled {
    color: var(--color-dark-grey);
    border-color: var(--color-dark-grey);
    position: relative;
    overflow: hidden;
    &:after {
      content: '';
      height: 100px;
      width: 1px;
      background-color: currentColor;
      position: absolute;
      transform: rotate(65deg);
      left: 50%;
    }
  }
  &.sku-item_active.sku-item_disabled {
    border-color: #5f5f67;
    color: #b0b0b0;
    background-color: #ededed;
    &:after {
      background-color: #5f5f67;
    }
  }
}
</style>
